module.exports = __webpack_public_path__ + "static/media/10-3.34fe77b6.mp3";